import { useRef, useState } from "react";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

function ImagePicker({ onPick }) {
  const inputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  // const [preview, setPreview] = useState(null);

  const openPicker = () => inputRef.current?.click();

  const handleFile = (file) => {
    if (!file) return;
    setFileName(file.name);
    // setPreview(URL.createObjectURL(file));
    onPick?.(file); // prosledi roditelju (UploadForm) ako treba
  };

  const onChange = (e) => handleFile(e.target.files?.[0]);

  const onDrop = (e) => {
    e.preventDefault();
    handleFile(e.dataTransfer.files?.[0]);
  };

  return (
    <div className="uploader">
      {/* Skriven, ali fokusabilan input */}
      <input
        id="image"
        ref={inputRef}
        type="file"
        name="image"
        accept="image/*"
        className="visually-hidden"
        onChange={onChange}
      />

      {/* Klikabilna zona (label) */}
      <label
        htmlFor="image"
        className="dropzone"
        onDragOver={(e) => e.preventDefault()}
        onDrop={onDrop}
        role="button"
        tabIndex={0}
      >
        <div className="dz-text">
          <CloudUploadIcon className="icon icon--pulse" aria-hidden /><span className="tagline">{fileName ? fileName : "ubacite ili prevucite sliku ovde"}</span>
        </div>
      </label>
        {/* {preview && (
        <div className="preview">
          <img src={preview} alt={`Pregled: ${fileName}`} />
        </div>
        )}
      <div className="file-meta" aria-live="polite">
        {fileName ? fileName : "Nije izabran fajl"}
      </div> */}

      {/* (opciono) Preview */}
      
    </div>
  );
}

export default ImagePicker;